<template>
  <v-menu bottom left offset-y origin="top right" transition="scale-transition">
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
        @click="fetchalerts(type)"
      >
        <v-badge color="red" overlap bordered>
          <template v-slot:badge>
            <span>{{ count || 0 }}</span>
          </template>

          <v-icon>{{ icon }}</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list :tile="false" nav>
      <div>
        <app-bar-item v-for="(n, i) in data" :key="`${icon}-${i}`">
          <v-list-item-title v-text="n.message" :to="n.link" />
        </app-bar-item>
      </div>
    </v-list>
  </v-menu>
</template>
<script>
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Component } from "vue-property-decorator";

@Component({
  props: {
    count: {
      default: null,
    },
    type: {
      default: null,
    },
    icon: {
      default: "mdi-map-marker-path",
    },
  },
})
export default class Menu extends Vue {
  data = [];
  fetched = false;

  async fetchalerts(kind) {
    if (!this.fetched) {
      let url =
        "/api/alerts/grid?_search=true&_search=false&nd=1431524012079&rows=5&page=1&sidx=priority&sord=desc";
      if (kind == "-tariff") {
        url += "&item=4";
      }
      if (kind == "-trip") {
        url += "&item=1";
      }
      if (kind == "-cargo") {
        url += "&item=2";
      }
      if (kind == "-car") {
        url += "&item=5";
      }
      if (kind == "-empRequest") {
        url = "/api/employee/req/grid?sord=desc&sidx=at&rows=6";
      }
      if (kind == "-incident") {
        url = "/api/incident/grid?sord=desc&sidx=at&rows=6";
      }
      if (kind == "-adhocRequest") {
        url = "/api/adhoc/grid?sord=desc&sidx=startTime&rows=6";
      }

      try {
        common.setLoading(true);
        const response = await doGet(url);
        this.fetched = true;
        common.setLoading(false);
        this.data = response.rows;
      } catch (e) {
        common.setLoading(false);
        common.setError(e.message);
      }
    }
  }
}
</script>